import { property } from "lodash";

import { DesignToken } from "@livechat/design-system-react-components";

import { ReportType } from "constants/reports/report-type";
import { withVar } from "themes/helpers";

import { IHeatmapData } from "../interfaces";

const heatmapKeys = {
  [ReportType.NewTicketsHeatmap]: "newTickets",
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function heatmapDeserializer(days: any, reportType: any): IHeatmapData {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chartLabels = days.map((element: any) => element.date);
  const chartSeries = days.reduce(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc: any, day: any, dayIndex: any) =>
      acc.concat(
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(day.data).map((hourData: any, hourIndex, hours) => {
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          const heatmapValue = property(heatmapKeys[reportType])(hourData);

          return {
            x: dayIndex,
            y: hours.length - hourIndex - 1,
            value: heatmapValue,
            color: heatmapValue === 0 ? withVar(DesignToken.SurfaceSecondaryDefault) : "",
          };
        })
      ),
    []
  );

  return {
    chartSeries,
    chartLabels,
  };
}
